import { SVGProps } from 'react'
import * as React from 'react'

const AudienceIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="151"
      height="150"
      viewBox="0 0 151 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_8122_40683)">
        <path
          d="M49.8867 84C68.3192 84 83.2617 69.0575 83.2617 50.625C83.2617 32.1925 68.3192 17.25 49.8867 17.25C31.4542 17.25 16.5117 32.1925 16.5117 50.625C16.5117 69.0575 31.4542 84 49.8867 84Z"
          fill="#7181FF"
        />
        <path
          d="M49.8868 94.5C22.3555 94.5338 0.0452286 116.877 0.0117188 144.45C0.0117188 147.515 2.49275 150 5.55331 150H94.2201C97.2807 150 99.7617 147.515 99.7617 144.45C99.7285 116.877 77.4182 94.5338 49.8868 94.5Z"
          fill="#7181FF"
        />
        <path
          d="M137.534 64.9688C130.293 65.3294 124.706 71.4753 125.035 78.7174C125.364 71.4753 119.777 65.3294 112.536 64.9688C105.296 65.3294 99.7083 71.4753 100.037 78.7174C100.037 89.529 114.136 102.196 121.16 107.833C123.425 109.647 126.645 109.647 128.91 107.833C135.934 102.209 150.033 89.529 150.033 78.7174C150.362 71.475 144.775 65.3294 137.534 64.9688Z"
          fill="#7181FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_8122_40683">
          <rect
            width="150"
            height="150"
            fill="white"
            transform="translate(0.046875)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default AudienceIcon
